import { Component } from '@angular/core';
import { GatewayService } from  'libs/gateway/src/lib/services/gateway.service';
import {  Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'cradua-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent  {
  title = 'mrsoftepims';
  isHome: boolean = true;
  id: any;

  single: any[] = [
    {
      "name": "Germany",
      "value": 8940000
    },
    {
      "name": "USA",
      "value": 5000000
    },
    {
      "name": "France",
      "value": 7200000
    },
      {
      "name": "UK",
      "value": 6200000
    }
  ];
  view: any[] = [700, 400];

  // options
  gradient: boolean = true;
  showLegend: boolean = true;
  showLabels: boolean = true;
  isDoughnut: boolean = false;
  legendPosition: string = 'below';

  colorScheme = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  };

  constructor(public gatewayService: GatewayService, private route: Router){

    this.route.routeReuseStrategy.shouldReuseRoute = function(){
      return false;
   }

   this.route.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
         // trick the Router into believing it's last link wasn't previously loaded
         this.route.navigated = false;
         // if you need to scroll back to top, here is the right place
         window.scrollTo(0, 0);
      }
  });
    this.route.events.subscribe((event:  NavigationEnd ) => {

      //console.log('event ', event.url)
      if(event.url !== undefined)
      {

        if(event.url === "/home" || event.url=== "/" || event.url === "/login" || event.url === "/auth/login" || event.url === "/auth/login/login" || event.url?.toLowerCase()?.includes("/auth/manage") || event.url === "/subscribe"
        || event.url === "/incidentregister"    )
        {
         this.isHome = true;
         this.gatewayService.isHome$.next(true);
       }else{
         this.isHome = false;
         this.gatewayService.isHome$.next(false);

       }
       //console.log("Home Variable ", this.isHome);

      }



     })
  }


  onSelect(data): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }
}
